import { DriverWorkCycle } from "@/models/common";
import { DriverWorkCyclesConstants } from "@/pages/DriverWorkCycles/DriverWorkCyclesConstants";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CommonButton } from "../common/buttons/CommonButton";

export type DriverWorkCycleDetailTabProps = {
  driverWorkCycles: DriverWorkCycle[];
  onClickAdd: () => void;
  onClickEdit: (cycleId: number) => void;
};

export const DriverWorkCycleDetailTab = ({
  driverWorkCycles,
  onClickAdd,
  onClickEdit,
}: DriverWorkCycleDetailTabProps) => (
  <TableContainer
    sx={{ width: "100%", backgroundColor: "#fff" }}
    className="table-container-width"
  >
    <Table size="small" sx={{ width: "100%" }} className="list-head">
      <TableHead>
        <TableRow>
          <TableCell className="table-cell-width-custom">
            {DriverWorkCyclesConstants.DriverWorkCycleName}
          </TableCell>
          <TableCell sx={{ minWidth: "320px" }}>
            {DriverWorkCyclesConstants.Shift}
          </TableCell>
          <TableCell className="table-cell-width-custom">
            {DriverWorkCyclesConstants.Description}
          </TableCell>
          <TableCell sx={{ textAlign: "right", pr: 0 }}>
            <CommonButton btnType="Add" onClickBtn={onClickAdd} />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody sx={{ wordBreak: "break-all" }}>
        {driverWorkCycles.map((row) => (
          <TableRow key={row.id} hover>
            <TableCell>{row.shortName ?? ""}</TableCell>
            <TableCell>
              {row.driverWorkShifts
                ?.map(({ shortName }) => shortName)
                .join(",") ?? ""}
            </TableCell>
            <TableCell>{row.description ?? ""}</TableCell>
            <TableCell sx={{ textAlign: "right", pr: 0 }}>
              <CommonButton
                btnType="Edit"
                onClickBtn={() => onClickEdit(row.id ?? 0)}
                disabled={row.isDefault}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
